var r = "__nol__icon";
function c(o) {
  var n = o;
  return n[r] = !0, n;
}
export {
  c
};
